'use client';

import type { ReactNode } from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

import { RADIUS } from 'src/theme/ui-tokens';

import { Iconify } from 'src/components/iconify';

import { HubConditionBar } from './hub-condition-bar';

/**
 * 허브 상세의 **머리 조건 줄** — 「목록으로」 + 조건 칩(브랜드·크리에이터 허브가 같이 쓴다).
 *
 * ```
 *   [< 목록으로] (기간 ▾) (제품군 ▾) (채널 ▾) …                         (actions — 줄 오른쪽 끝)
 * ```
 *
 * 🔑 「목록으로」는 **칩 줄 왼쪽 끝**에 서고 칩과 함께 구르지 않는다 — 폰에서 칩 줄이 옆으로 굴러도 늘 보인다
 *   (폰은 「목록」 두 글자로 줄인다). 칩 줄 모양은 `HubConditionBar` 가 쥔다(넓으면 접히고 폰이면 한 줄로 구른다).
 * ⚠️ 공유 페이지(비회원)에는 세우지 않는다 — 고칠 조건도 돌아갈 목록도 없다.
 */
export function HubDetailToolbar({ onBack, children, actions }: { onBack: () => void; children: ReactNode; actions?: ReactNode }) {
  return (
    <Stack direction="row" spacing={0.5} alignItems="flex-start">
      <Button
        size="small"
        color="inherit"
        onClick={onBack}
        startIcon={<Iconify icon="solar:alt-arrow-left-linear" width={14} />}
        sx={{ flexShrink: 0, height: 28, borderRadius: RADIUS.pill, px: { xs: 1, md: 1.5 }, typography: 'uiAction', color: 'text.secondary', whiteSpace: 'nowrap' }}
      >
        <Box component="span" sx={{ display: { xs: 'none', md: 'inline' } }}>목록으로</Box>
        <Box component="span" sx={{ display: { md: 'none' } }}>목록</Box>
      </Button>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <HubConditionBar narrowed={0} onReset={noop} actions={actions}>
          {children}
        </HubConditionBar>
      </Box>
    </Stack>
  );
}

// ---- 이하 비공개 ----------------------------------------------------------

/** 상세 칩 줄은 「초기화」를 세우지 않는다(`narrowed` 0) — 부르지 않는 자리다 */
function noop() {}
